import { render, staticRenderFns } from "./LayoutFront.vue?vue&type=template&id=2354a034&"
import script from "./LayoutFront.vue?vue&type=script&lang=js&"
export * from "./LayoutFront.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports